export default __webpack_public_path__ + "static/media/credit-card.953e8031.svg";